import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';

import './css/general.css';
import styles from './css/Results.module.css';

interface ResultProps extends RouteComponentProps {
    // Define the props here
  }
  
  interface ResultState {
    // Define the state here
    challengeList: Challenge[];
    challenges: number;
    level: number
  }

  interface ChallengeInterface{
    challengeId: number,
    challengeTitle: string,
    challengeScore: number,
    questions: number
  }

  class Challenge implements ChallengeInterface {
    challengeId: number;
    challengeTitle: string;
    challengeScore: number;
    questions: number;
  
    constructor(challengId: number, challengeTitle: string, challengeScore: number, questions: number) {
      this.challengeId = challengId;
      this.challengeTitle = challengeTitle
      this.challengeScore = challengeScore
      this.questions = questions
    }
  
  }
  
  
  class Results extends React.Component<ResultProps, ResultState> {
    constructor(props: ResultProps) {
      super(props);
  
      this.state = {
        challengeList:[
            {
                challengeId: 0,
                challengeTitle: "",
                challengeScore: 0,
                questions: 0
            }
        ],
        challenges: 0,
        level: 0
      };

      this.getLevel();
      this.getChallenges();
    }

    async getChallenges(){
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");

      axiosInstance
      .get(
          "/Results/Employee/" + id + "/Subject/" + localStorage.getItem("subjectId"),
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
      .then((res) => {
          //console.log(res.data);
          res.data.forEach((element: any) => {
              //console.log(element.challenge);
              this.state.challengeList.push({
                  challengeId: element.challenge.id,
                  challengeTitle: element.challenge.title,
                  challengeScore: element.score,
                  questions: element.challenge.questions.length
              })
          });
          console.log(this.state.challengeList)
          this.state.challengeList.splice(0, 1);
          // Meest recente resultaten bovenaan
          this.state.challengeList.sort(function(a, b){return b.challengeId - a.challengeId});
          this.setState({ challengeList: this.state.challengeList, challenges: this.state.challengeList.length});
          //console.log(this.state.challengeList);

        })
    }

    async getLevel(){
      var id = localStorage.getItem("id");
      var token = localStorage.getItem("token");
  
      let challengesDone: number = 0
  
    axiosInstance
    .get(
        "/Results/Employee/" + id,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
    .then((res) => {
        res.data.forEach((quiz: any) => {
          if(quiz.score >= 0) {
            challengesDone ++
          }
      });
      let level:number = 1
      let challengesForNextLevel:number[] = [3,4,3,2]
      let challengesToDo = challengesForNextLevel[0]
      let index: number = 0
      
      while(challengesDone >= challengesToDo) {
         challengesDone -= challengesToDo;
         level ++;
         if(index % 2 == 0) {
             challengesForNextLevel.push(3)
         } else {
             challengesForNextLevel.push(2)
         }
         index ++
         challengesToDo = challengesForNextLevel[index]
      }
  
      this.setState({level: level})
      })
    }


    goToMoodOverview(){
        const {history} = this.props;
        localStorage.setItem("subjectId", "" + localStorage.getItem("subjectId"))
        localStorage.setItem("challengeList", JSON.stringify(this.state.challengeList))
        history.push("/moodOverviewSubject");
    }

    goToChallengeResult(challengeId: number, challengeTitle: string, challengeScore: number, questions: number){
        const {history} = this.props;
        localStorage.setItem("challengeId", "" + challengeId)
        localStorage.setItem("challengeTitle", "" + challengeTitle)
        localStorage.setItem("challengeScore", "" + challengeScore)
        localStorage.setItem("amountOfQuestions", "" + questions)
        localStorage.setItem("subjectId", "" + localStorage.getItem("subjectId"))
        history.push("/challengeresult");
    }

    render(){
      let challengeDone:any[] = [];
      this.state.challengeList.forEach((challenge) => {
        if(challenge.challengeScore >= 0) {
          challengeDone.push(
            <IonCard 
            className={`${styles.panel} ${styles.quiz}`}
            key={challenge.challengeId}
            onClick={() => this.goToChallengeResult(challenge.challengeId, challenge.challengeTitle, challenge.challengeScore, challenge.questions)}>
                <p className={(styles.challengeTitle)}>{challenge.challengeTitle}</p>
            </IonCard>
            )
          } else {
            challengeDone.push(
              <IonCard 
              className={`${styles.panel} ${styles.quiz} ${styles.disabledPanel}`}
              key={challenge.challengeId}>
                <p className={(styles.challengeTitle)}>{challenge.challengeTitle}</p>
                <p className={(styles.text)}>Je hebt deze challenge niet voltooid</p>
            </IonCard>
            )
          }
        });
        
        let level = this.state.level
        
        let moodOverview;
        if(this.state.challenges >= 5 && level >= 4){
        moodOverview =
        <IonCard className={`${styles.panel} ${styles.moodOverview}`} onClick={() => this.goToMoodOverview()}>
          <p className={(styles.moodTitle)}>Overzicht mood</p>
          <p className={(styles.text)}>Klik hier om een overzicht te bekijken van je moods gedurende deze case</p>
        </IonCard>
        } else if(this.state.challenges >= 5 && level < 4){
        moodOverview =
        <IonCard className={`${styles.panel} ${styles.moodOverview} ${styles.disabledPanel}`}>
          <p className={(styles.moodTitle)}>Overzicht mood</p>
          <p className={(styles.text)}>Om een overzicht te kunnen zien, moet je minstens level 4 zijn</p>
        </IonCard>
        } else if(this.state.challenges < 5 && level >= 4){
        moodOverview =
        <IonCard className={`${styles.panel} ${styles.moodOverview} ${styles.disabledPanel}`}>
          <p className={(styles.moodTitle)}>Overzicht mood</p>
          <p className={(styles.text)}>Er zijn momenteel onvoldoende resultaten beschikbaar om een overzicht te kunnen tonen</p>
        </IonCard>
        } else {
        moodOverview =
        <IonCard className={`${styles.panel} ${styles.moodOverview} ${styles.disabledPanel}`}>
          <p className={(styles.moodTitle)}>Overzicht mood</p>
          <p className={(styles.text)}>Om een overzicht te kunnen zien, moet je minstens level 4 zijn en minstens 5 quizzen van dit onderwerp voltooid hebben</p>
        </IonCard>
        }

        return(
            <IonPage>
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                    <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                        <IonTitle>Resultaten</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen>
                    <div className= {(styles.quizNames)}>
                      {challengeDone}
                    </div>

                    {moodOverview}
                   
              </IonContent>
            </IonPage>
        );
    }
};

export default withRouter(Results);
